module.exports = __webpack_public_path__ + "3e7c4f28621ef45803065d311d4c53f0.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/CY.svg
// module id = GESN
// module chunks = 0